import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from '@/firebaseConfig'

Vue.use(Vuex)

// Modules
import user from './modules/user'
import company from './modules/company'
import inventory from './modules/invetory'
import locations from './modules/locations'
import currencies from './modules/currencies'
import snackbar from './modules/snackbar'
import modals from './modules/modals'
import products from './modules/products'
import search from './modules/search'
import layout from './modules/layout'
import signin from './modules/signin'
import fileUploader from './modules/fileUploader'

const store = new Vuex.Store({
  modules: {
    user,
    company,
    inventory,
    locations,
    currencies,
    snackbar,
    modals,
    products,
    search,
    layout,
    signin,
    fileUploader
  },
  state: {
    appLoading: false,
  },
  mutations: {
    setAppLoading(state, newVal) {
      state.appLoading = newVal
    }
  },
  actions: {
    clearState({ dispatch }) {
      dispatch('clearUserData')
      dispatch('clearCompanyData')
      dispatch('clearInventoryData')
      dispatch('clearLocationsData')
    },
    setAppLoading({ commit }, val) {
      commit('setAppLoading', val)
    }
  },
})

auth.onAuthStateChanged((user) => {
  if (user) {
    const cleanUserObj = (({ uid, email, displayName, emailVerified }) => ({
      uid,
      email,
      displayName,
      emailVerified
    }))(user)
    store.commit('setCurrentUser', cleanUserObj)
    store.dispatch('getCurrentUserScopes')
  }
})

export default store
